import React, { useRef } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import {
	useCallbackWithCondition,
	useMemoWithCondition,
} from '@atlassian/jira-feature-flagging-utils/src/utils/hooks';
import { FocusRestorationContext } from '../../controllers/focus-restoration-context.tsx';

// The idea of this component is to provide a focus restoration context for the project menu items.
// The context will be read deep down the tree where the menuItem which supports drag-and-drop is rendered.

function ContentWithDragAndDropEnabled({ children }: { children: React.ReactNode }) {
	const shouldRestoreFocusRef = useRef<boolean>(false);

	const clearRestoreFocus = useCallbackWithCondition(
		() => {
			shouldRestoreFocusRef.current = false;
		},
		[],
		() => fg('jfp-magma-stability-2025-07-16'),
	);

	const contextValue = useMemoWithCondition(
		() => ({
			shouldRestoreFocusRef,
			clearRestoreFocus,
		}),
		[clearRestoreFocus],
		() => fg('jfp-magma-stability-2025-07-16'),
	);

	return (
		<FocusRestorationContext.Provider value={contextValue}>
			{children}
		</FocusRestorationContext.Provider>
	);
}

export const ContentWithDragAndDrop = componentWithCondition(
	() => expVal('blu-6314-drag-and-drop-projects-sidebar-experiment', 'isEnabled', false),
	ContentWithDragAndDropEnabled,
	({ children }: { children: React.ReactNode }) => children,
);
